
import Vue from 'vue';
import Buefy from 'buefy';
import VueMq from 'vue-mq';
import App from './App.vue';
import store from './store/store.js';
import router from './router.js';
import * as i18nSetup from './i18n-setup.js';

import 'buefy/dist/buefy.css';
import './dark-mode.css';

Vue.use(Buefy, {defaultIconPack: 'fas'});
Vue.use(VueMq, {
  breakpoints: {
    mobile: 900,
    desktop: Infinity,
  }
});

const i18n = i18nSetup.i18n;
i18nSetup.loadLanguage('en').then(() => {
  new Vue({
    router,
    i18n,
    store,
    render: h => h(App)
  }).$mount('#app')
})
